
angular.module('app.directives.link_highlight', [])
  .directive('stateSelect',
      ['$rootScope', function ($rootScope) {
    return {
      restrict: 'EA',
      replace: 'false',
      scope: false,
      link: function($scope, $elem, attrs) {

        $scope.$watch(
          function() {
            return $rootScope.userState;
          },
          function(newState) {
            newState = newState.toLowerCase();
            var ele = $elem.find("li[data-state='" + newState + "']");
            $elem.find('li[data-state]').removeClass('selected');
            ele.addClass('selected');
            var displayAttr = attrs.display;
            if (displayAttr) {
              // Expecting one link, but if there are more, pick the first.
              $scope[displayAttr] = ele.first().text();
            }
          }
        );
      }
    };
  }])
  .directive('linkSelect',
      ['$timeout', '$window', function ($timeout, $window) {
    return {
      restrict: 'EA',
      replace: 'false',
      scope: false,
      link: function($scope, $elem, attrs) {
        $timeout(function() {
          var path = $window.location.pathname;
          var link = $elem.find("a[href='" + path + "']");
          if (link) {
            link.addClass('selected');
            var displayAttr = attrs.display;
            if (displayAttr) {
              // Expecting one link, but if there are more, pick the first.
              $scope[displayAttr] = link.first().text();
            }
          }
        });
      }
    };
  }]);